import { render, staticRenderFns } from "./CostBearerInvoicePreview.vue?vue&type=template&id=331e3ad5&scoped=true"
import script from "./CostBearerInvoicePreview.vue?vue&type=script&lang=ts"
export * from "./CostBearerInvoicePreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e3ad5",
  null
  
)

export default component.exports